import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import { iconPencil } from '~utils/svgIcons';
import '~components/input/style.scss';
import '../style.scss';

function PersonalDataLoader({ isMobile }) {
    return (
        <div className="personal-data">
            <form>
                <h3>
                    <Skeleton
                        width={isMobile ? 145 : 190}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 23.96 : 40}
                    />
                </h3>
                <div className="personal-data__input-group">
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                    </div>
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                    </div>
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                    </div>
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                    </div>
                </div>

                <h3>
                    <Skeleton
                        width={isMobile ? 185 : 245}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 23.96 : 40}
                    />
                </h3>
                <div className="personal-data__input-group">
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                        <div className="personal-data__input-icon">{iconPencil}</div>
                    </div>
                    <div className="personal-data__input-wrap">
                        <div className="input">
                            <div className="input__input"></div>
                            <div className="input__error"></div>
                        </div>
                        <div className="personal-data__input-icon">{iconPencil}</div>
                    </div>
                </div>
            </form>
        </div>
    );
}

PersonalDataLoader.propTypes = {
    isMobile: PropTypes.bool.isRequired,
};

export default PersonalDataLoader;
export { PersonalDataLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-settings/personal-data/loader/index.js